var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "sign-billing-dialog",
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "450px",
            "close-on-click-modal": false,
            "show-close": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", "label-position": "right" } },
            [
              _c(
                "div",
                { staticClass: "el-form-item-wrapper" },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.AnnotationDate") } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "markDate",
                          type: "date",
                          "value-format": "yyyy-MM-dd",
                          disabled: true
                        },
                        model: {
                          value: _vm.markDate,
                          callback: function($$v) {
                            _vm.markDate = $$v
                          },
                          expression: "markDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Clearing.Annotator") } },
                    [
                      _c("cargo-advance-select", {
                        staticStyle: { width: "210px" },
                        attrs: {
                          no: "userId",
                          "select-type": _vm.selectTypeNames.basic_data_User,
                          filterable: "",
                          "default-value": _vm.$store.getters.userId,
                          disabled: true
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary", no: "save" },
                  on: { click: _vm.saveEvent }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                { attrs: { no: "cancel" }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }